import { useListRunners, type PlainRunner } from "@/queries/runner-queries";
import { useEffect, useState } from "react";
import { RunnerKind } from "gitpod-next-api/gitpod/v1/runner_configuration_pb";
import { useAuthenticatedUser } from "@/queries/user-queries";

export function useAvailableRunners({ enabled }: { enabled: boolean } = { enabled: true }) {
    const { data: user } = useAuthenticatedUser();
    const { data: remoteRunners, isPending: isPendingRemoteRunners } = useListRunners({ kind: RunnerKind.REMOTE });
    const {
        data: localRunners,
        isLoading: isLoadingLocalRunners,
        isFetching: isFetchingLocalRunners,
        isPending: isPendingLocalRunners,
    } = useListRunners({ creatorId: user?.id, kind: RunnerKind.LOCAL });

    const [availableRunners, setAvailableRunners] = useState<PlainRunner[]>([]);
    const [initialzed, setInitialized] = useState<boolean>(false);

    const isLoading =
        isPendingRemoteRunners || isLoadingLocalRunners || isFetchingLocalRunners || isPendingLocalRunners;

    useEffect(() => {
        if (!user || !enabled) {
            return;
        }
        if (isLoading) {
            return;
        }
        const joined = [...(remoteRunners || []), ...(localRunners || [])];
        setAvailableRunners(joined);
        setInitialized(true);
    }, [user, remoteRunners, localRunners, isLoading, enabled]);

    return {
        isLoading: !initialzed || isLoading,
        availableRunners,
    };
}
